import styled, { createGlobalStyle } from 'styled-components';

export const EditorStyle = createGlobalStyle`
  .comments-editor {
    .DraftEditor-root {
      max-width: 100%;
      border: 0;
      background: ${({ theme }) => theme.colors.commentsFormBg};
      border-radius: 4px;
      outline: none;
      padding: 10px;
      height: 58px;
      transition: height 0.15s ease-out;
      color: ${({ theme }) => theme.colors.color100};
      ${({ theme }) => theme.fontTypes.type1}
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }

      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;

      &.collapsed {
        height: 110px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }

    div.DraftEditor-editorContainer,
    div.public-DraftEditor-content {
      height: 100%;
    }

    &.collapsed {
      .DraftEditor-root {
        height: 100px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    }
  }
`;

export const Placeholder = styled.div(({ theme }) => {
  return `
    color: ${theme.colors.gray_500};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    z-index: 10;
  `;
});

export const ActionButton = styled.button`
  width: 40px;
  height: 40px;
  border: 0;
  padding: 0;
  position: relative;
  background: ${({ theme }) => theme.colors.commentsFormBg};
  cursor: pointer;

  &:first-child {
    border-bottom-left-radius: 4px;
  }

  &::before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: ${(props: any) => {
      return `url('/images/icon-${props['data-icon']}--${
        props['data-active'] ? 'green' : props['data-theme'] === 'dark' ? 'light' : 'dark'
      }.png') no-repeat top left / 20px 20px`;
    }};
  }

  &:hover {
    &::before {
      background: ${(props: any) => {
        return `url('/images/icon-${props['data-icon']}--green.png') no-repeat top left / 20px 20px`;
      }};
    }
  }
`;

export const SubmitButton = styled.button`
  background: ${({ theme }) => theme.colors.commentsFormBg};
  border: 0;
  padding: 0 20px;
  font-size: 14px;
  text-transform: uppercase;
  border-bottom-right-radius: 4px;
  color: ${({ theme }) => theme.colors.color100};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary_400};
  }
`;
